export default function Contracts() {
    return <>
      Contracts' Actions, here you can interact with the app's contracts soon.
    </>
  }